// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ChartsAnnotatorController from "./charts_annotator_controller";
application.register("charts-annotator", ChartsAnnotatorController);

import GeoChartController from "./geo_chart_controller";
application.register("geo-chart", GeoChartController);

import PaddleClassicController from "./paddle_classic_controller";
application.register("paddle-classic", PaddleClassicController);

import PaddleController from "./paddle_controller";
application.register("paddle", PaddleController);

import PageRefresherController from "./page_refresher_controller";
application.register("page-refresher", PageRefresherController);

import PaginatedController from "./paginated_controller";
application.register("paginated", PaginatedController);

import ProfitwellController from "./profitwell_controller";
application.register("profitwell", ProfitwellController);

import SwitcherController from "./switcher_controller";
application.register("switcher", SwitcherController);
